/*
 *
 * Furniture constants
 *
 */

enum ActionTypes {
  ADD_TO_SHELVES_SELECTION = 'app/CONFIGURATOR/SELECTION/ADD_TO_SHELVES_SELECTION',
  SHELVES_SELECTION = 'app/CONFIGURATOR/SELECTION/SHELVES_SELECTION_REQUEST',
  SHELVES_SELECTION_SUCCESS = 'app/CONFIGURATOR/SELECTION/SHELVES_SELECTION_SUCCESS',
  SHELF_SELECTION_CLEAR = 'app/CONFIGURATOR/SELECTION/SHELF_SELECTION_CLEAR',
  DRAWERS_SHELVES_SELECTION = 'app/CONFIGURATOR/SELECTION/DRAWER_SHELVES_SELECTION',
  DOORS_SHELVES_SELECTION = 'app/CONFIGURATOR/SELECTION/DOORS_SHELVES_SELECTION',
  BIG_SHELVES_SHELVES_SELECTION = 'app/CONFIGURATOR/SELECTION/BIG_SHELVES_SHELVES_SELECTION',
}

export default ActionTypes;
